import { GetQueueRequestById } from 'domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetQueueRequestById
  extends BaseHttpService<GetQueueRequestById.Model>
  implements GetQueueRequestById
{
  async get(): Promise<GetQueueRequestById.Model> {
    return await this.request('get', {});
  }
}
